export const banners = [
  {
    imageURL:
      'https://static.shop-apotheke.com/media/content/150x300/marktplatz-large.png',
    link: '/lp/neues-marktplatz-sortiment/',
    className: 'o-SubmenuCard__banner u-visuallyhidden@small-tiny',
    isImage: true,
    qa: 'banner-new-header',
  },
]
